import { render, staticRenderFns } from "./DriversHeader.vue?vue&type=template&id=2f38db23&scoped=true&"
import script from "./DriversHeader.vue?vue&type=script&lang=js&"
export * from "./DriversHeader.vue?vue&type=script&lang=js&"
import style0 from "./DriversHeader.vue?vue&type=style&index=0&id=2f38db23&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f38db23",
  null
  
)

export default component.exports